<script>
import { HorizontalBar, mixins } from "vue-chartjs";
import _ from "../../views/Utility/utility";
const { reactiveProp } = mixins;

export default {
    extends: HorizontalBar,
    mixins: [reactiveProp],
    computed: {
        options() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: true,
                    titleFontSize: 14,
                    titleMarginBottom: 8,
                    bodyFontSize: 15,
                    bodySpacing: 10,
                    callbacks: {
                        label: (tooltipItems, data) => {
                            const datasetIndex = tooltipItems.datasetIndex;
                            const label = data.datasets[datasetIndex].label;
                            return `${label}: ${_.getMoneyFormat(tooltipItems.value)}`;
                        },
                    },
                },
                onClick: this.handle,
                scales: {
                    xAxes: [{
                        stacked: true,
                        display: true
                    }],
                    yAxes: [
                        {
                            stacked: true,
                            display: true
                        },
                    ],
                },
            };
        },
    },
    mounted() {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options);
    },
    methods: {
        handle(point, event) {
        },
    },
};
</script>
